import { render, staticRenderFns } from "./RecipientsStep.vue?vue&type=template&id=448d65e8&scoped=true&"
import script from "./RecipientsStep.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecipientsStep.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecipientsStep.vue?vue&type=style&index=0&id=448d65e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d65e8",
  null
  
)

export default component.exports